var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDataRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2451 7.83086L15.5101 10.9659C14.8801 13.6734 13.6351 14.7684 11.2951 14.5434C10.9201 14.5134 10.5151 14.4459 10.0801 14.3409L8.82013 14.0409C5.69263 13.2984 4.72513 11.7534 5.46013 8.61836L6.19513 5.47586C6.34513 4.83836 6.52513 4.28336 6.75013 3.82586C7.62763 2.01086 9.12013 1.52336 11.6251 2.11586L12.8776 2.40836C16.0201 3.14336 16.9801 4.69586 16.2451 7.83086Z",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2938 14.5417C10.8288 14.8567 10.2438 15.1192 9.53129 15.3517L8.34629 15.7417C5.36879 16.7017 3.80129 15.8992 2.83379 12.9217L1.87379 9.95922C0.913791 6.98172 1.70879 5.40672 4.68629 4.44672L5.87129 4.05672C6.17879 3.95922 6.47129 3.87672 6.74879 3.82422C6.52379 4.28172 6.34379 4.83672 6.19379 5.47422L5.45879 8.61672C4.72379 11.7517 5.69129 13.2967 8.81879 14.0392L10.0788 14.3392C10.5138 14.4442 10.9188 14.5117 11.2938 14.5417Z",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 6.39844L13.118 7.32094",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74609 9.30078L10.9211 9.85578",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDataRequests);
export default __webpack_public_path__ + "static/media/open-data-requests.a35a3f8bf4aefa3fe285a57b2b9c32ff.svg";
export { ForwardRef as ReactComponent };